// extracted by mini-css-extract-plugin
module.exports = {"section":"Q_section__Yqfob"};